<template>
  <div
    :class="`--${position}`"
    class="push-layout"
  >
    <div class="push-layout__content">
      <slot name="main" />
    </div>
    <div
      :class="{ '--hide': isHidden }"
      :style="`width: ${dynamicSidebarWidth};`"
      class="push-layout__sidebar"
    >
      <hidden-elements-container
        :position="position"
        :hide-after-milliseconds="hideAfterMilliseconds"
        :default-open="defaultOpen"
        :click-outside="clickOutside"
        :buttonText="buttonText"

        :style="`width: ${sidebarWidth};`"

        @toggle="onToggle"
      >
        <slot name="sidebar" />
      </hidden-elements-container>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HiddenContainerPush',

  props: {
    /**
     * To which side is the container positioned<br />
     * `left` or `right`
     */
    position: {
      type: String,
      required: false,
      default: 'right',
      validator: (value) => ['right', 'left'].includes(value),
    },

    /**
     * Hide the container after amount of milliseconds
     */
    hideAfterMilliseconds: {
      type: Number,
      required: false,
      default: 0,
    },

    /**
     * Should the container remain open when visiting the page
     */
    defaultOpen: {
      type: Boolean,
      required: false,
      default: false,
    },

    /**
     * Hide container on click outside
     */
    clickOutside: {
      type: Boolean,
      required: false,
      default: true,
    },

    /**
     * The text in the toggle button to open the container
     */
    buttonText: {
      type: String,
      required: false,
      default: 'Bekijk de content',
    },

    /**
     * The width of the sidebar
     */
    sidebarWidth: {
      type: String,
      required: false,
      default: '700px',
    },
  },

  data() {
    return {
      isHidden: false,
      initialized: false,
    };
  },

  computed: {
    dynamicSidebarWidth() {
      if (!this.initialized && (!this.defaultOpen && this.hideAfterMilliseconds === 0)) {
        return '0';
      }

      if (this.isHidden) {
        return '0';
      }

      return this.sidebarWidth;
    },
  },

  mounted() {
    this.initialized = true;
  },

  methods: {
    onToggle(isHidden) {
      this.isHidden = isHidden;
    },
  },
};
</script>

<style lang="scss" scoped>
  .push-layout {
    display: grid;
    grid-template-areas: 'main sidebar';
    grid-template-columns: 9fr auto;
    height: 100vh;
    width: 100%;

    &__content {
      grid-area: main;
      height: 100vh;
    }

    &__sidebar {
      grid-area: sidebar;
      height: 100vh;
      transition: all .8s;
    }

    &.\--left {
      grid-template-areas: 'sidebar main';
      grid-template-columns: auto 9fr;

      .push-layout__sidebar {
        direction: rtl;

        // stylelint-disable selector-max-universal
        > * {
          direction: ltr;
        }
      }
    }
  }
</style>
